import '../../scripts/common';
import '../../scripts/animate';
import Component from '../base/Component';

import Breadcrumbs from '../base/Breadcrumbs';
import PageScrollBtn from '../simple/PageScrollBtn';
import DiagnosisMenu from '../DiagnosisMenu';
import DiagnosisForm from '../DiagnosisForm';
import DiagnosisFeatures from '../DiagnosisFeatures';

import './styles.css';

/**
 * Страница диагностики
 */
export default class DiagnosisPage extends Component {
    static className = 'diagnosis-page';
}

$(() => {
    Breadcrumbs.create();
    PageScrollBtn.create();
    DiagnosisMenu.create();
    DiagnosisForm.create();
    DiagnosisFeatures.create();
});
